export enum CookieNames {
  FIREBASE_TOKEN = 'firebase-token',
  FIREBASE_MSISDN = 'firebase-msisdn',
  PP_STATE = 'pp-state',
  PP_DATE = 'pp-date',
}

export enum CookieStateValues {
  accepted = '1',
  rejected = '0',
}

export const HOURS_TO_REJECT = 48;
export const MS_IN_HOUR = 1000 * 60 * 60;
